import { Component, OnInit } from '@angular/core';
import { isAnonymousEnabled, pushSurveyAlertIfNeeded, setAnonymousEnabled } from '../utils';
import { CybersocxdrService } from 'src/app/shared/services/xtendedsoc/cybersocxdr.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cybersocxmenu',
  templateUrl: './cybersocxdrmenu.component.html',
  styleUrls: ['./cybersocxdrmenu.component.scss'],
})
export class CybersocxdrMenuComponent implements OnInit {
  anonymousEnabled: boolean;

  constructor(
    private cybersocService: CybersocxdrService,
    private alertService: AlertService,
    private translate: TranslateService
  ) {
    this.anonymousEnabled = isAnonymousEnabled();
  }

  ngOnInit() {
    pushSurveyAlertIfNeeded(this.cybersocService, this.alertService, this.translate);
  }

  handleAnonymousToggleChange(newValue: InputEvent) {
    setAnonymousEnabled(this.anonymousEnabled);
  }
}
